import useUser, { isAuthorizedUser } from './use-user'

export const useShowChangePasswordPage = () => {
  const { user } = useUser()

  return {
    showChangePasswordPage: isAuthorizedUser(user) && !user.impersonator,
  }
}
